export enum ErrorCodes {
    FEATURES_UNDEFINED = '[CNF-001]',
    PROPERTIES_UNDEFINED = '[CNF-002]',
    STYLES_UNDEFINED = '[CNF-003]',
    COGNITO_UNDEFINED = '[CNF-003]',
    // other error codes...
  }